module.exports = __webpack_public_path__ + "static/media/preview2.a7cc1418.png";